import { Box, Flex } from '@chakra-ui/layout';
import { Image } from '@chakra-ui/react';

import clientLogos from '../../../../images/client-logos.svg';
import { MarkdownRenderer } from '../Chart/TextChart/MarkdownRenderer';
import {
  REPORT_PAGE_WIDTH,
  REPORT_THEME,
} from '../PageConfigProvider/constants';

const halfWidth = REPORT_PAGE_WIDTH / 2;
const reportCenterPadding = `max(calc(50% - ${halfWidth}px), ${REPORT_THEME.margins.minCenterMargin}px)`;

const ABOUT_MARKDOWN = `## About Revelio Labs data
Revelio Labs provides workforce intelligence. We absorb and standardize hundreds of millions of public employment records to create the world's first universal HR database, allowing us to see current workforce composition of any company. We use the most advanced techniques in data science and statistical modeling to provide clean, reliable workforce data, which we additionally enrich with our proprietary models for greater insight into workforce trends. With our salary prediction model, we are able to estimate salaries for more than 1.4 billion unique positions worldwide, using individual-level information such as job title, seniority level, company, and location.`;

const CONTACT_MARKDOWN = `## Contact
Thank you for your interest in our data.

By ingesting the universe of publicly available online profiles, job postings, employee sentiment reviews, and layoff notices, Revelio Labs has created a comprehensive source of workforce data that can be used to analyze companies, occupations, skills, and activities. In addition to attrition, our team of labor economists and data scientists can create customized reports on industry outlooks, talent intelligence, DEI, and more.

For additional information on the custom insights we can offer, please reach out to [info@reveliolabs.com](mailto:info@reveliolabs.com)`;

const GET_IN_TOUCH_MARKDOWN = `#### Get in touch
Reach out for additional information on the custom insights we can offer.

#### Email us
info@reveliolabs.com

#### Visit us
860 Broadway, 5th floor, New York, NY 10003`;

export const ReportFooterPage = () => {
  return (
    <Box
      position="relative"
      width="100%"
      height="100%"
      data-footer-page="true"
      backgroundColor="white"
      sx={{
        WebkitPrintColorAdjust: 'exact !important',
        printColorAdjust: 'exact !important',
      }}
    >
      <Flex
        position="absolute"
        left={reportCenterPadding}
        right={reportCenterPadding}
        top="6%"
        bottom="6%"
        direction="column"
        gap="2rem"
      >
        <Box width="100%" mb={4}>
          <Flex direction="row" gap="10" alignItems="center">
            <Box flex="3">
              <MarkdownRenderer content={ABOUT_MARKDOWN} />
            </Box>
            <Box flex="1">
              <Image
                src={clientLogos}
                alt="Client logos"
                width="100%"
                height="auto"
                maxHeight="280px"
                objectFit="contain"
                loading="eager"
              />
            </Box>
          </Flex>
        </Box>
        <Flex direction="row" gap="10" alignItems="center">
          <Box flex="3">
            <MarkdownRenderer content={CONTACT_MARKDOWN} />
          </Box>

          <Box flex="2">
            <MarkdownRenderer content={GET_IN_TOUCH_MARKDOWN} />
          </Box>
        </Flex>
      </Flex>
    </Box>
  );
};
